import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import LoginPage from './pages/login/LoginPage';
import ItemPage from './pages/Item/ItemPage';
import './index.css';
import { AuthProvider } from './pages/login/AuthContext';
import ProtectedRoute from './pages/login/ProtectedRoute';
import GamesPage from './pages/games/GamesPage';
import GiftsPage from './pages/gifts/GiftsPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path='/login' element={<LoginPage />} />
          {/* Protected routes - must come before catch-all routes */}
          <Route 
            path='/' 
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path='/games' 
            element={
              <ProtectedRoute>
                <GamesPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path='/gifts' 
            element={
              <ProtectedRoute>
                <GiftsPage />
              </ProtectedRoute>
            } 
          />
          {/* Public routes for game links - no authentication required */}
          <Route path='/:gameId/:itemId' element={<ItemPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
